import { createFileRoute, useNavigate, Navigate } from "@tanstack/react-router";
import { useAuth } from "@/contexts/auth-context";
import { fetchWithAuth } from "@/lib/auth-client";
import type { CreatePurchaseRequestRequest } from "@procureflow/shared-types";
import { PRForm, type PRFormInitialValues } from "@/components/pr-form";

export const Route = createFileRoute("/purchase-requests/new")({
  head: () => ({
    meta: [{ title: "New Purchase Request — ProcureFlow" }],
  }),
  component: PRCreatePage,
});

const EMPTY_INITIAL: PRFormInitialValues = {
  title: "",
  cost_centre: "",
  required_by_date: "",
  justification: "",
  line_items: [],
};

function PRCreatePage() {
  const { user } = useAuth();
  const navigate = useNavigate();

  if (!user || user.role !== "Requester") {
    return <Navigate to="/purchase-requests" />;
  }

  async function handleCreate(body: CreatePurchaseRequestRequest) {
    const res = await fetchWithAuth("/api/purchase-requests", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });

    if (!res.ok) {
      const errBody = await res.json().catch(() => ({}));
      throw new Error(errBody.message ?? "Failed to save draft.");
    }

    const { data } = await res.json();
    navigate({ to: "/purchase-requests/$id", params: { id: data.id } });
  }

  return (
    <PRForm
      mode="create"
      initialValues={EMPTY_INITIAL}
      onSubmit={handleCreate}
      onCancel={() => navigate({ to: "/purchase-requests" })}
    />
  );
}
